import { get } from '../../01-helpers/services/ajax';

/* ========================================================================== */

const defaultParams = {};

export default (data => new Promise((resolve, reject) => {
    get(
        '/umbraco/api/cart/cartCount'
    ).done(data => resolve(data)).fail(reject);
}));
